import { useMutation } from '@apollo/client'
import {
  ConfirmInsuranceEligibility,
  ConfirmInsuranceEligibilityInput,
  ConfirmInsuranceEligibilityVariables,
} from '../../types'
import { CONFIRM_INSURANCE_ELIGIBILITY } from './operations'

interface ConfirmInsuranceEligibilityProps {
  onCompleted?: () => void
  filter?: ConfirmInsuranceEligibilityInput
}

export const useConfirmInsuranceEligibility = ({ onCompleted }: ConfirmInsuranceEligibilityProps) =>
  useMutation<ConfirmInsuranceEligibility, ConfirmInsuranceEligibilityVariables>(
    CONFIRM_INSURANCE_ELIGIBILITY,
    {
      onCompleted,
    }
  )
